<template>
  <div>
    <f7-block class="mt-1 mb-1" inset>
      <f7-segmented tag="p" strong>
        <f7-button :active="tab_selected === 'statistics'" @click.prevent="tab_selected = 'statistics'">
          Statistics
        </f7-button>
        <f7-button :active="tab_selected === 'workers'" @click.prevent="tab_selected = 'workers'">
          Workers
        </f7-button>
        <f7-button :active="tab_selected === 'rewards'" @click.prevent="tab_selected = 'rewards'">
          Rewards
        </f7-button>
        <f7-button :active="tab_selected === 'payouts'" @click.prevent="tab_selected = 'payouts'">
          Payouts
        </f7-button>
      </f7-segmented>
    </f7-block>
    <template v-if="tab_selected === 'statistics'">
      <f7-block class="mt-0 mb-1 pt-1 pb-1" strong inset v-if="!_.isEmpty(wallet_data)">
        <div style="display: flex">
          <div style="margin-right: 10px">
            <img :src="require(`@/assets/crypto-icons/${wallet_info.coin.toUpperCase()}.png`)" style="max-width: 45px; max-height: 80px"/>
          </div>
          <div>
            <p class="mt-0 mb-0">
              <f7-link popover-open=".popover-menu-wallet">{{ wallet_info.name }}</f7-link>
            </p>
            <small class="mb-0 color-gray">UNPAID BALANCE</small>
            <h1 class="mt-0 mb-0">
              {{
                wallet_data.stats.balance / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}</h1>
            <small class="mb-0" v-if="!_.isEmpty(coin_info)">
              1 {{ wallet_info.coin }} = {{ coin_info[0].price_usd | numeral('0.00') }} USD = {{
                coin_info[0].price_btc |
                  numeral('0.000000')
              }} BTC
            </small>
          </div>
          <div style="margin-left: auto; text-align: right">
            <small class="mb-0">UNCOFIRMED</small>
            <h3 class="mt-0 mb-0">
              {{
                wallet_data.stats.immature / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}</h3>
            <small class="mb-0">TOTAL PAID</small>
            <h3 class="mt-0 mb-0">
              {{
                wallet_data.stats.paid / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}</h3>
          </div>
        </div>
        <f7-row no-gap>
          <f7-col width="20" class="text-align-center border-right-solid p-0">
            <small class="xs">LAST SHARE</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.stats.lastShare | moment('from', 'now', true) }}</p>
          </f7-col>
          <f7-col width="35" class="text-align-center border-right-solid p-0">
            <small class="xs">CURRENT HASHRATE</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.currentHashrate / 1000000 | numeral('0.00') }}
              <br/><small>MH/s</small>
            </p>
          </f7-col>
          <f7-col width="30" class="text-align-center border-right-solid p-0">
            <small class="xs">AVG HASHRATE</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.hashrate / 1000000 | numeral('0.00') }}
              <br/><small>MH/s</small>
            </p>
          </f7-col>
          <f7-col width="15" class="text-align-center p-0">
            <small class="xs">WORKERS</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.workersOnline }}/{{ wallet_data.workersTotal }}</p>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block inset>
        <line-chart v-if="chart_loaded" style="height: 250px" :chartdata="chart_data" :options="chart_options"/>
      </f7-block>
      <f7-block class="mt-1 mb-1 pt-1 pb-1" strong inset v-if="!_.isEmpty(wallet_data) && !_.isEmpty(coin_info)">
        <h4 class="text-align-center mt-0 mb-0">ESTIMATED EARNINGS</h4>
        <f7-row>
          <f7-col></f7-col>
          <f7-col class="text-align-right">
            <small>{{ wallet_info.coin }}</small>
          </f7-col>
          <f7-col class="text-align-right">
            <small>USD</small>
          </f7-col>
          <f7-col class="text-align-right">
            <small>BTC</small>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col>
            <small>DAY</small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * coin_info[0].price_usd | numeral('0.00')
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * coin_info[0].price_btc | numeral('0.000000')
              }}
            </small>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col>
            <small>WEEK</small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 7 | numeral(coin_configs[wallet_info.coin].numeral)
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 7 * coin_info[0].price_usd | numeral('0.00')
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 7 * coin_info[0].price_btc | numeral('0.000000')
              }}
            </small>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col>
            <small>MONTH</small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 30 | numeral(coin_configs[wallet_info.coin].numeral)
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 30 * coin_info[0].price_usd | numeral('0.00')
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 30 * coin_info[0].price_btc | numeral('0.000000')
              }}
            </small>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col>
            <small>YEAR</small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 365 | numeral(coin_configs[wallet_info.coin].numeral)
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 365 * coin_info[0].price_usd | numeral('0.00')
              }}
            </small>
          </f7-col>
          <f7-col class="text-align-right">
            <small class="lg">
              {{
                wallet_data['24hreward'] / coin_configs[wallet_info.coin].point * 365 * coin_info[0].price_btc |
                  numeral('0.000000')
              }}
            </small>
          </f7-col>
        </f7-row>
      </f7-block>
    </template>
    <template v-if="tab_selected === 'workers'">
      <f7-block class="mt-0 mb-1 pt-1 pb-1" strong inset v-if="!_.isEmpty(wallet_data)">
        <div style="display: flex">
          <div style="margin-right: 10px">
            <img :src="require(`@/assets/crypto-icons/${wallet_info.coin.toUpperCase()}.png`)" style="max-width: 45px; max-height: 80px"/>
          </div>
          <div>
            <p class="mt-0 mb-0">
              <f7-link popover-open=".popover-menu-wallet">{{ wallet_info.name }}</f7-link>
            </p>
            <small class="mb-0 color-gray">UNPAID BALANCE</small>
            <h1 class="mt-0 mb-0">
              {{
                wallet_data.stats.balance / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}</h1>
            <small class="mb-0" v-if="!_.isEmpty(coin_info)">
              1 {{ wallet_info.coin }} = {{ coin_info[0].price_usd | numeral('0.00') }} USD = {{
                coin_info[0].price_btc |
                  numeral('0.000000')
              }} BTC
            </small>
          </div>
          <div style="margin-left: auto; text-align: right">
            <small class="mb-0">UNCOFIRMED</small>
            <h3 class="mt-0 mb-0">
              {{
                wallet_data.stats.immature / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}</h3>
            <small class="mb-0">TOTAL PAID</small>
            <h3 class="mt-0 mb-0">
              {{
                wallet_data.stats.paid / coin_configs[wallet_info.coin].point | numeral(coin_configs[wallet_info.coin].numeral)
              }}</h3>
          </div>
        </div>
        <f7-row no-gap>
          <f7-col width="20" class="text-align-center border-right-solid p-0">
            <small class="xs">LAST SHARE</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.stats.lastShare | moment('from', 'now', true) }}</p>
          </f7-col>
          <f7-col width="35" class="text-align-center border-right-solid p-0">
            <small class="xs">CURRENT HASHRATE</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.currentHashrate / 1000000 | numeral('0.00') }} <br/>
              <small>MH/s</small>
            </p>
          </f7-col>
          <f7-col width="30" class="text-align-center border-right-solid p-0">
            <small class="xs">AVG HASHRATE</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.hashrate / 1000000 | numeral('0.00') }} <br/>
              <small>MH/s</small>
            </p>
          </f7-col>
          <f7-col width="15" class="text-align-center p-0">
            <small class="xs">WORKERS</small>
            <p class="mt-0 pb-05 mb-0 fs-sm">{{ wallet_data.workersOnline }}/{{ wallet_data.workersTotal }}</p>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block class="mt-1" strong inset v-if="!_.isEmpty(wallet_data)">
        <f7-row no-gap class="mb-1 pl-05">
          <f7-col class="p-0">
            <small class="lg">Worker</small>
          </f7-col>
          <f7-col class="text-align-right p-0">
            <small class="lg">Last Share</small>
          </f7-col>
          <f7-col class="text-align-right p-0">
            <small class="lg">HR</small>
          </f7-col>
          <f7-col class="text-align-right p-0">
            <small class="lg">AVG HR</small>
          </f7-col>
        </f7-row>
        <f7-row no-gap v-for="(worker, idx) in wallet_data.workers" :key="idx" class="border-bottom-solid mb-05 pb-05 pt-05 pl-05" :class="{'bg-color-green-opacity': !worker.offline}">
          <f7-col class="p-0">{{ idx }}</f7-col>
          <f7-col class="text-align-right p-0 fs-sm">{{ worker.lastBeat | moment('from', 'now', true) }}
          </f7-col>
          <f7-col class="text-align-right p-0">
            {{ worker.hr / 1000000 | numeral('0.0') }}
            <small class="xs">MH/s</small>
          </f7-col>
          <f7-col class="text-align-right p-0">
            {{ worker.hr2 / 1000000 | numeral('0.0') }}
            <small class="xs">MH/s</small>
          </f7-col>
        </f7-row>
      </f7-block>
    </template>
    <template v-if="tab_selected === 'rewards'">
      <f7-block class="mt-1" strong inset v-if="!_.isEmpty(wallet_data)">
        <f7-row no-gap class="mb-1 pl-05 pr-05">
          <f7-col width="35" class="p-0">
            <small>Reward Date</small>
          </f7-col>
          <f7-col width="20" class="text-align-left p-0">
            <small>Amount</small>
          </f7-col>
          <f7-col class="text-align-center p-0">
            <small>Status</small>
          </f7-col>
          <f7-col width="20" class="text-align-right p-0">
            <small>Share</small>
          </f7-col>
        </f7-row>
        <virtual-list style="height: 400px; overflow-y: auto; overflow-x: hidden;" :data-key="'blockheight'" :extra-props="{ config: coin_configs[wallet_info.coin] }" :data-sources="wallet_data.rewards || []" :data-component="rewardItemComponent"/>
      </f7-block>
    </template>
    <template v-if="tab_selected === 'payouts'">
      <f7-block class="mt-1" strong inset v-if="!_.isEmpty(wallet_data)">
        <f7-row class="mb-1 pl-05 pr-05">
          <f7-col width="40" class="p-0">
            <small>Payout Date</small>
          </f7-col>
          <f7-col width="20" class="text-align-center p-0">
            <small>Duration</small>
          </f7-col>
          <f7-col class="text-align-right p-0 pl-1">
            <small>Amount</small>
          </f7-col>
          <f7-col width="20" class="text-align-right p-0">
            <small>TX</small>
          </f7-col>
        </f7-row>
        <virtual-list style="height: 400px; overflow-y: auto; overflow-x: hidden" :data-key="'tx'" :extra-props="{ config: coin_configs[wallet_info.coin] }" :data-sources="payments || []" :data-component="payoutItemComponent"/>
      </f7-block>
    </template>
    <f7-popover class="popover-menu-wallet">
      <f7-list>
        <f7-list-item link @click.prevent="copyWallet" popover-close title="Copy Address"></f7-list-item>
      </f7-list>
    </f7-popover>
  </div>
</template>
<style scoped>
small {
  font-size : 9px;
}
small.xs {
  font-size : 8px;
}
.fs-sm{
  font-size: 12px;
}
small.lg {
  font-size : 12px;
}
.border-right-solid {
  border-right : 1px solid rgba(255, 255, 255, 0.2);
}
.border-bottom-solid {
  border-right : 1px solid rgba(255, 255, 255, 0.2);
}
.bg-color-green-opacity {
  background-color : rgba(106, 255, 0, 0.43) !important;
}
</style>
<script>
import {
  f7Button,
  f7Segmented,
  f7Block,
  f7Row,
  f7Col,
  f7Popover,
  f7List,
  f7ListItem,
  f7Link
} from 'framework7-vue';
import LineChart from "./components/LineChart";
import VirtualList from 'vue-virtual-scroll-list'
import RewardItem from "./components/RewardItem";
import PayoutItem from "./components/PayoutItem";
import _ from "lodash";
import { mapState } from 'vuex';

export default {
  components: {
    f7Button,
    f7Segmented,
    f7Block,
    f7Row,
    f7Col,
    LineChart,
    VirtualList,
    f7Popover,
    f7List,
    f7ListItem,
    f7Link
  },
  props: {
    wallet_info: Object
  },
  data() {
    return {
      tab_selected: 'statistics',
      wallet_data: {
        currentHashrate: 0,
        hashrate: 0,
        workers: [],
        payments: [],
        rewards: [],
        minerCharts: [],
        stats: {
          balance: 0,
          immature: 0,
          paid: 0,
          lastShare: 0
        },
        workersOnline: 0,
        workersTotal: 0,
        '24hreward': 0
      },
      miner_charts: [],
      coin_info: {},
      chart_loaded: false,
      chart_options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Hashrate Report'
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: true
            },
          }]
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
      },
      rewardItemComponent: RewardItem,
      payoutItemComponent: PayoutItem,
      intervalGetInfo: null
    }
  },
  computed: {
    ...mapState(['coin_configs']),
    chart_data() {
      let labels = _.reverse(this.miner_charts.map(a => this.$moment(a.x * 1000).format('YYYY-MM-DD HH:mm:ss')));
      let datas = _.reverse(this.miner_charts.map(a => Math.round(((a.y / 1000000) + Number.EPSILON) * 100) / 100));
      return {
        labels: !_.isEmpty(this.wallet_data) ? labels : [],
        datasets: [
          {
            label: 'Hashrate',
            fill: false,
            borderWidth: 1,
            pointRadius: 1,
            backgroudColor: 'red',
            borderColor: 'red',
            data: !_.isEmpty(this.wallet_data) ? datas : []
          }
        ]
      }
    },
    payments() {
      let payments = [];
      this._.each(this.wallet_data.payments, (item, idx) => {
        if (idx + 1 < this.wallet_data.payments.length) {
          item.duration = this.$moment(item.timestamp).diff(this.wallet_data.payments[idx + 1].timestamp);
        }
        else{
          item.duration = 0;
        }
        payments.push(item);
      });
      return payments;
    }
  },
  methods: {
    getWalletInfo(showLoading = false) {
      if (showLoading) {
        this.$f7.preloader.show();
      }
      this.$store.dispatch('get2MinersWalletInfo', {
        coin: this.wallet_info.coin,
        address: this.wallet_info.address
      }).then((data) => {
        this.wallet_data = data;

        return this.$store.dispatch('get2MinersWalletHashrate', {
          coin: this.wallet_info.coin,
          address: this.wallet_info.address
        });
      }).then((data) => {
        this.miner_charts = data.actual;
        return this.$store.dispatch('getCoinInfo', this.wallet_info.coin);
      }).then((data) => {
        this.coin_info = data;
        this.chart_loaded = true;
        if (showLoading) {
          this.$f7.preloader.hide();
        }
      }).catch((err) => {
        if (showLoading) {
          this.$f7.preloader.hide();
        }
        this.$f7.dialog.alert(err, 'ERROR!', () => {
          this.$f7router.back();
        });
      });
    },
    copyWallet() {
      this.$copyText(this.wallet_info.address);
      this.$f7.dialog.alert('', 'COPIED!');
    }
  },
  mounted() {
    this.getWalletInfo(true);
    this.intervalGetInfo = setInterval(this.getWalletInfo, 30000);
  },
  destroyed() {
    clearInterval(this.intervalGetInfo);
  }
};
</script>
